import React, { useState } from "react";

export default function ForgotPasswordForm() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/forgot-password`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    const data = await response.json();
    if (!response.ok) {
      setMessage(data.error || "Something went wrong.");
      return;
    }
    setMessage(data.message);
    setEmail("");
  };

  return (
    <form onSubmit={handleSubmit}>
      {message && <p className="message">{message}</p>}
      <div className="form-field">
        <label className="form-label">Email</label>
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>
      <button type="submit" className="btn-auth">Send reset link</button>
    </form>
  );
}
